import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "St Patrick's Day Extravaganza",
  date: new Date(2024, 2, 17),
  img: "/img/clover.jpeg",
  tracks: [
    {
      title: "Kickin' Ass & Taking Names",
      src: "/songs/2024-03-17/kickin_ass_taking_names.mp3",
      duration: 502.104,
    },
    {
      title: "Droppin' Dimes",
      src: "/songs/2024-03-17/droppin_dimes.mp3",
      duration: 817.896,
    },
    {
      title: "Keepin' Up With The Joneses",
      src: "/songs/2024-03-17/keepin_up_with_the_joneses.mp3",
      duration: 937.104,
    },
    {
      title: "Chest Of Family Things",
      src: "/songs/2024-03-17/chest_of_family_things.mp3",
      duration: 836.592,
    },
    {
      title: "Get On Your Dancin' Shoes",
      src: "/songs/2024-03-17/get_on_your_dancin_shoes.mp3",
      duration: 1505.256,
    },
    {
      title: "Rodeo Clown",
      src: "/songs/2024-03-17/rodeo_clown.mp3",
      duration: 776.328,
    },
    {
      title: "Philosopher's Stone",
      src: "/songs/2024-03-17/philosophers_stone.mp3",
      duration: 551.424,
    },
    {
      title: "Outlaws' Ball",
      src: "/songs/2024-03-17/outlaws_ball.mp3",
      duration: 904.176,
    },
    {
      title: "Universal Healthcare",
      src: "/songs/2024-03-17/universal_healthcare.mp3",
      duration: 638.448,
    },
    {
      title: "Lil Nightcap",
      src: "/songs/2024-03-17/lil_nightcap.mp3",
      duration: 2080.224,
    },
  ],
};
export default album;
